import { FlexColumn } from '@gorila-shared-ui/components';
import { Filter } from 'baseui/table';
import { memo } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import useFleetMaintenanceRules from '../hooks/useFleetMaintenanceRules';
import FleetMaintenanceTypeSelect from '../shared/FleetMaintenanceTypeSelect';
import FleetTriggerTypeSelect from '../shared/FleetTriggerTypeSelect';

export function FleetMaintenanceRulesFilters() {
  const { theme, css, overrides } = useStyles();
  const { filters, hasActiveFilters, resetFilters, onChangeFilter } = useFleetMaintenanceRules();

  return (
    <Filter
      active={hasActiveFilters}
      overrides={overrides.filtersOverrides(resetFilters)}
    >
      <FlexColumn
        classNames={css({
          paddingTop: theme.sizing.scale500,
          paddingBottom: theme.sizing.scale500,
        })}
        gap={theme.sizing.scale200}
      >
        <FleetTriggerTypeSelect
          selectedId={filters.triggerType}
          onChangeId={(triggerType) => onChangeFilter('triggerType', triggerType)}
          showEmptyOption
          inline
          isFilter
        />
        <FleetMaintenanceTypeSelect
          selectedMaintenanceTypeId={filters.maintenanceTypeId}
          onChangeMaintenanceTypeId={(maintenanceTypeId) => onChangeFilter('maintenanceTypeId', maintenanceTypeId)}
          showEmptyOption
          inline
          isFilter
        />
      </FlexColumn>
    </Filter>
  );
}

export default memo(FleetMaintenanceRulesFilters);
